import styled from "styled-components";
import Row from "./Row";

export default styled(Row)`
  flex-direction: column;
`;